import { createCustomAction } from 'typesafe-actions';

import { PresetData } from './typings';

export const loadPresets = createCustomAction('@presets/LOAD');
export const showError = createCustomAction('@presets/SHOW_ERROR', type => (error: string) => ({ type, error }));
export const loadPresetsSuccess = createCustomAction('@presets/LOAD_SUCCESS', type => {
    return (items: PresetData[]) => ({ type, items });
});

export type LoadPresets = ReturnType<typeof loadPresets>;

export type PresetsAction = LoadPresets | ReturnType<typeof loadPresetsSuccess> | ReturnType<typeof showError>;
